import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface Config {
  errors: unknown;
  Config: Config;
  isAuthenticated: boolean;
}

@Module
export default class ConfigModule extends VuexModule implements Config {
  errors = {};
  Config = {} as Config;
  listType = {};
  listMenu = {};
  isAuthenticated = !!JwtService.getToken();

  get getConfigData() {
    return this.Config;
  }

  get getlistMenuData() {
    return this.listMenu;
  }

  get getListTypeData() {
    return this.listType;
  }

  @Mutation
  [Mutations.LIST_TYPE_DATA](listType) {
    this.listType = listType;
  }

  @Mutation
  [Mutations.LIST_MENU_DATA](listMenu) {
    this.listMenu = listMenu;
  }

  @Action
  [Actions.LIST_TYPE](data) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("master-data", data)
        .then(({ data }) => {
          this.context.commit(Mutations.LIST_TYPE_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    }
  }

  @Action
  [Actions.LIST_MENU](data) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("menu_option", data)
        .then(({ data }) => {
          this.context.commit(Mutations.LIST_MENU_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    }
  }
}
